import { createFileRoute } from "@tanstack/react-router";
import LansareCamioane from "@/pages/LansareCamioane";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/lansare-camioane/")({
  head: () => routeHead("/lansare-camioane/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LansareCamioane />
  );
}
